import React from 'react';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Carrito from '../components/Carrito';

const CarritoPage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Banner />
      <div style={{ flex: 1 }}>
        <Carrito />
      </div>
      <Footer />
    </div>
  );
};

export default CarritoPage;
